<template>
  <v-card class="pa-3">
    <v-row>
      <v-col>
        <v-hover>
          <template v-slot:default="{ hover }">
            <v-card flat>
              <div v-bind:id="'qrcode-' + index">
                <vue-qr style="width:300px;" :logoSrc="logo" :text="qrUrl" :id="index" :size="600" />
              </div>
              <v-fade-transition v-if="false">
                <v-overlay v-if="hover" absolute>
                  <v-btn fab dark small class="mx-2">
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </v-overlay>
              </v-fade-transition>
            </v-card>
          </template>
        </v-hover>
      </v-col>

      <v-col>
        <v-card-actions class="mx-2">
          <!-- <v-btn v-if="location.codeId" icon @click="print('qrcode-' + index)">
            <v-icon>mdi-printer</v-icon>
          </v-btn>
          <v-btn disabled v-else icon>
            <v-icon>mdi-printer</v-icon>
          </v-btn>-->
          <v-spacer></v-spacer>
          <v-btn v-if="location.id" icon @click="showDeleteDialog">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-btn disabled v-else icon>
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-card-actions>

        <div>
          <v-card-title primary-title>
            <v-text-field
              class="headline"
              solo
              flat
              v-model="location.name"
              :placeholder="$t('Location Name')"
              :hint="$t('Name of your location')"
              prepend-inner-icon="mdi-pencil"
            ></v-text-field>
          </v-card-title>

          <v-card-text>
            <v-switch
              v-model="location.isTakeAway"
              :label="$t('TakeAway')"
              :disabled="!$store.getters.canOrder"
            />

            <v-switch
              :disabled="!$store.getters.canOrder"
              v-model="location.canOrder"
              :label="$t('Can order')"
            />
            <v-switch
              :disabled="!$store.getters.canOrder"
              v-model="location.isNotified"
              :label="$t('Notify on ready')"
            />
          </v-card-text>

          <v-card-actions class="d-flex justify-end">
            <v-btn color="primary" outlined @click="save">{{ $t("Save") }}</v-btn>
          </v-card-actions>
        </div>
      </v-col>
    </v-row>
    <v-dialog v-model="deleteDialog" width="55vw">
      <v-card flat>
        <v-card-title>{{ $t("Delete {name}?", { name: location.name }) }}</v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="deleteDialog = false">{{ $t("Cancel") }}</v-btn>
          <v-btn text color="primary" @click="deleteLocation(location)">{{ $t("Delete") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import VueQr from "vue-qr";
import LocationCode from "@/model/location_code.js";
import Location from "@/model/location.js";

export default {
  props: {
    location: {
      type: Object,
      default() {
        return new Location();
      }
    },
    logo: {},
    index: {}
  },
  components: {
    VueQr
  },
  data() {
    return {
      deleteDialog: false
    };
  },

  computed: {
    qrUrl() {
      return this.location.codeId
        ? `https://bell.merlocode.com//${this.location.codeId}`
        : "https://i.giphy.com/media/RX3vhj311HKLe/giphy.webp";
    }
  },

  methods: {
    async save() {
      let location = this.location;

      if (!location.codeId) {
        let restaurantId = this.$store.getters.restaurant.id;
        let locationCode = new LocationCode({
          restaurant: restaurantId,
          type: "qr"
        });
        location.save().then(function(locationValue) {
          location.id = locationValue.id;
          locationCode.location = locationValue.id;
          locationCode.save().then(function(locationCodeValue) {
            location.codeId = locationCodeValue.id;
            location.save();
          });
        });
        location = new Location();
      } else {
        location.save();
      }
      this.$emit("closeEditLocation");
    },

    showDeleteDialog() {
      this.deleteDialog = true;
    },

    deleteLocation(location) {
      this.deleteDialog = false;
      location.delete();
      this.$emit("closeEditLocation");
    }
  }
};
</script>
